import React from 'react';
import { NavLink } from 'react-router-dom';
import './../../Tela_Sobre/Tela_Conheca/style.css'
import Grid from '@material-ui/core/Grid';
import SideNav from './../../../components/SideNav';
import primeiraimg from './../../../assets/home-ilustracao-paciente.png';
import segundaimg from './../../../assets/botao-medico_tutor.png';
import joao from './../../../assets/joao.jpg';
import logotoda from './../../../assets/logo-rede-convida-home.png';
import linkedin from './../../../assets/linkedin.png'
import instagram from './../../../assets/instagram.png'

//Alteração do mateus pra não interferir nas outras urls
window.location = "#carro-1";

export default function Tela_Conheca() {    
    return(
        <>      
            <SideNav />
            <body>
            
            < section id= "tela1" >
            <img src={primeiraimg} alt="Convida" id="primeiraimg"></img>
                <div class="textotela1">
                    <h1 class= "estilo1" id="introempresa">
                        <b>REDE CONVIDA</b> 
                    </h1>
                    
                    <h4 class="estilo12">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod temporin 
                        cididunt ut labore et dolore magnaali. 
                    </h4>
                    
                    <a href="pagina2.html" class="button1"><b>CONHEÇA NOSSA EQUIPE!</b></a>
                    </div> 
            </section>



            < section id= "tela2" >
                    <div class="textotela2">
                        <h1 class= "estilo2" id="introempresa">
                            <b>QUEM SOMOS</b> 
                        </h1>

                        <h4 class="estilo22">
                            Conheça mais sobre a rede ConVida. 
                        </h4>
                        
                        <Grid container spacing={0} direction="row" justify="center" alignItems="center" style={{ minHeight: '80vh', maxWidth: '100%' }}> 
                            <Grid item xs={0}></Grid>
                            <Grid item xs={9} sm={6} md={6} lg={4} align="center" position="botton">
                                <img src={segundaimg} alt="Esquerda" id="segundaimg"></img>
                            </Grid>
                            
                            <Grid item xs={9} sm={6} md={6} lg={4} align="center">
                            <p class="estilo221">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. 
                                </p>

                                <a href="pagina2.html" class="button2"><b>SEJA UM VOLUNTÁRIO!</b></a> 
                            </Grid>
                            
                            <Grid item xs={1}></Grid>
                        </Grid>
                    </div>
            </section>




            < section id= "tela3" >

                        <div class="container">
                            <div class="carro carro-1" id="carro-1">
                                
                              <h1 class= "estilo3" id="introempresa">
                                     <b>NOSSA EQUIPE</b> 
                                 </h1>

                                <h1 class= "integrantes" id="introempresa">
                                    <b>IDEALIZADORAS</b> 
                                </h1>

                                
                                <div class="post2">

                                    <div class="card-deck">
                                        <div class="botao"> 
                                            <a id="irvoltar" href="#carro-3"> Voltar </a>
                                            </div>
                                        <div class="cardnew">
                                        <img id="fotinhas" src= {joao} alt="John"></img>
                                        <h1 class="h1new">John Doe</h1>
                                        <p class="titlenew">CEO Founder, Example</p>
                                        <p class="pnew">Harvard University</p>
                                        <a href="#" id="a"><i class="fa fa-dribbble"></i></a> 
                                        <a href="#" id="a"><i class="fa fa-twitter"></i></a> 
                                        <a href="#" id="a"><i class="fa fa-linkedin"></i></a> 
                                        <a href="#" id="a"><i class="fa fa-facebook"></i></a> 
                                        <a href="https://www.pinterest.de/pin/156992736990173873/" class="buttonnew">Contact</a> 
                                        </div>
                            
                                        <div class="cardnew">
                                        <img id="fotinhas" src={joao} alt="John"></img>
                                        <h1 class="h1new">John Doe</h1>
                                        <p class="titlenew">CEO Founder, Example</p>
                                        <p class="pnew">Harvard University</p>
                                        <a href="#" id="a"><i class="fa fa-dribbble"></i></a> 
                                        <a href="#" id="a"><i class="fa fa-twitter"></i></a> 
                                        <a href="#" id="a"><i class="fa fa-linkedin"></i></a> 
                                        <a href="#" id="a"><i class="fa fa-facebook"></i></a> 
                                        <a href="https://www.pinterest.de/pin/156992736990173873/" class="buttonnew">Contact</a> 
                                        </div>

                                        <div class="botao"> 
                                        <a id="irvoltar" href="#carro-2"> Avançar </a>
                                            </div>
                                    </div>
                                 </div>
                            </div>





                            <div class="carro carro-2" id="carro-2">
                            <h1 class= "estilo3" id="introempresa">
                                     <b>NOSSA EQUIPE</b> 
                                 </h1>
                            <h1 class= "integrantes" id="introempresa">
                                    <b>VOLUNTÁRIOS TI</b> 
                                </h1>

                                <div class="post2">
                                    <div class="card-deck">

                                    <div class="botao"> 
                                            <a id="irvoltar" href="#carro-3"> Voltar </a>
                                            </div>
                                        <div class="cardnew">
                                        <img id="fotinhas" src= {joao} alt="John"></img>
                                        <h1 class="h1new">John Doe</h1>
                                        <p class="titlenew">CEO Founder, Example</p>
                                        <p class="pnew">Harvard University</p>
                                        <a href="#" id="a"><i class="fa fa-dribbble"></i></a> 
                                        <a href="#" id="a"><i class="fa fa-twitter"></i></a> 
                                        <a href="#" id="a"><i class="fa fa-linkedin"></i></a> 
                                        <a href="#" id="a"><i class="fa fa-facebook"></i></a> 
                                        <a href="https://www.pinterest.de/pin/156992736990173873/" class="buttonnew">Contact</a> 
                                        </div>
                            
                                        <div class="cardnew">
                                        <img id="fotinhas" src={joao} alt="John"></img>
                                        <h1 class="h1new">John Doe</h1>
                                        <p class="titlenew">CEO Founder, Example</p>
                                        <p class="pnew">Harvard University</p>
                                        <a href="#" id="a"><i class="fa fa-dribbble"></i></a> 
                                        <a href="#" id="a"><i class="fa fa-twitter"></i></a> 
                                        <a href="#" id="a"><i class="fa fa-linkedin"></i></a> 
                                        <a href="#" id="a"><i class="fa fa-facebook"></i></a> 
                                        <a href="https://www.pinterest.de/pin/156992736990173873/" class="buttonnew">Contact</a> 
                                        </div>

                                        <div class="cardnew">
                                        <img id="fotinhas" src={joao} alt="John"></img>
                                        <h1 class="h1new">John Doe</h1>
                                        <p class="titlenew">CEO Founder, Example</p>
                                        <p class="pnew">Harvard University</p>
                                        <a href="#" id="a"><i class="fa fa-dribbble"></i></a> 
                                        <a href="#" id="a"><i class="fa fa-twitter"></i></a> 
                                        <a href="#" id="a"><i class="fa fa-linkedin"></i></a> 
                                        <a href="#" id="a"><i class="fa fa-facebook"></i></a> 
                                        <a href="https://www.pinterest.de/pin/156992736990173873/" class="buttonnew">Contact</a> 
                                        </div>

                                        <div class="botao"> 
                                        <a id="irvoltar" href="#carro-3">Avançar</a>
                                            </div>

                                    </div>
                                 </div>
                            </div>






                            <div class="carro carro-3" id="carro-3">
                            <h1 class= "estilo3" id="introempresa">
                                     <b>NOSSA EQUIPE</b> 
                                 </h1>
                            <h1 class= "integrantes" id="introempresa">
                                    <b>VOLUNTÁRIOS DE COMUNICAÇÃO</b> 
                                </h1>
                                
                                <div class="post2">
                                    <div class="card-deck">
                                    <div class="botao"> 
                                            <a id="irvoltar" href="#carro-2"> Voltar </a>
                                            </div>
                                        <div class="cardnew">
                                        <img id="fotinhas" src= {joao} alt="John"></img>
                                        <h1 class="h1new">John Doe</h1>
                                        <p class="titlenew">CEO Founder, Example</p>
                                        <p class="pnew">Harvard University</p>
                                        <a href="#" id="a"><i class="fa fa-dribbble"></i></a> 
                                        <a href="#" id="a"><i class="fa fa-twitter"></i></a> 
                                        <a href="#" id="a"><i class="fa fa-linkedin"></i></a> 
                                        <a href="#" id="a"><i class="fa fa-facebook"></i></a> 
                                        <a href="https://www.pinterest.de/pin/156992736990173873/" class="buttonnew">Contact</a> 
                                        </div>
                            
                                        <div class="cardnew">
                                        <img id="fotinhas" src={joao} alt="John"></img>
                                        <h1 class="h1new">John Doe</h1>
                                        <p class="titlenew">CEO Founder, Example</p>
                                        <p class="pnew">Harvard University</p>
                                        <a href="#" id="a"><i class="fa fa-dribbble"></i></a> 
                                        <a href="#" id="a"><i class="fa fa-twitter"></i></a> 
                                        <a href="#" id="a"><i class="fa fa-linkedin"></i></a> 
                                        <a href="#" id="a"><i class="fa fa-facebook"></i></a> 
                                        <a href="https://www.pinterest.de/pin/156992736990173873/" class="buttonnew">Contact</a> 
                                        </div>

                                        <div class="botao"> 
                                        <a id="irvoltar" href="#carro-1">Avançar</a>
                                            </div>

                                    </div>
                                 </div>
                            </div>
                        </div>
            </section>






            < section id= "footer" >

                <a href="pagina2.html" class="logos">
                <img src={logotoda} alt="Logo" id="logofooter"></img>
                </a>
                    <h1 class= "estilofooter" id="introempresa">
                        emai@institucional.com.br | lorem ipsum dolor
                    </h1>
                    <Grid container spacing={0} direction="row" justify="center" alignItems="center" style={{ minHeight: '10vh', maxWidth: '100%' }}>
                    <Grid item xs={0} sm={5} md={5} lg={5}></Grid>

                    <Grid item xs={12} sm={2} md={2} lg={2} align="center" position="botton"> 
                    <div class="sociais">
                    <img href="https://www.linkedin.com/company/rede-convida" class="logolinkedin" src={linkedin} alt="Linkedin"></img>
                    <img href="https://www.instagram.com/redeconvida/" class= "logoinsta" src={instagram} alt="Instagram"></img>
                    </div>
                    </Grid>

                    <Grid item xs={0} sm={5} md={5} lg={5}></Grid>
                    </Grid>
            </section>

            </body> 

        </>
    );
}